import React, { useMemo } from 'react';
import RadioGroupField from 'components/RadioGroupField';
import { useTranslation } from 'react-i18next';
import LinkIcon from 'icons/Link.icon';
import EyeIcon from 'icons/Eye.icon';
import { LISTING_STAGE } from 'models/Listing';

import './DefaultStep.styles.scss';
import './DefaultStep.styles.responsive.scss';

const DefaultStep: React.FC = () => {
  const { t } = useTranslation();

  const options = useMemo(
    () => [
      {
        value: LISTING_STAGE.PRIVATE,
        label: (
          <>
            <LinkIcon />
            <span>
              <span>{t('restrictedAccess')}</span>
              <span className="description">
                {t('onlyPeopleYouInviteCanSeeIt')}
              </span>
            </span>
          </>
        ),
      },
      {
        value: LISTING_STAGE.PUBLIC,
        label: (
          <>
            <EyeIcon />
            <span>
              <span>{t('publicToAttractBuyers')}</span>
              <span className="description">{t('appearsOnMarketplace')}</span>
            </span>
          </>
        ),
      },
    ],
    [t],
  );

  return (
    <div className="default-step">
      <p>{t('shareAccessDescription')}</p>
      <RadioGroupField name="listingStage" options={options} styled />
    </div>
  );
};

export default DefaultStep;
